/* tslint:disable */
/* eslint-disable */

import { BaseAPI } from '../baseApi';
import { StatisticsInterval, StatisticsOverview } from '../types';

export class StatisticsAPI extends BaseAPI {
  /**
   * Statistiken i det nya formatet (/statistics/v2). Allt är räknat i backend och redan
   * filtrerat efter vad mottagaren får se. null betyder att anropet misslyckades; vyerna
   * skiljer det från en period utan aktiviteter.
   */
  async getOverview(
    interval: StatisticsInterval,
    start: Date,
    end: Date,
    supervisedTag?: string,
  ): Promise<StatisticsOverview | null> {
    const queryParameters: any = {
      intervalStartDate: toLocalDateString(start),
      intervalEndDate: toLocalDateString(end),
    };
    if (supervisedTag !== undefined) {
      queryParameters['supervisedTag'] = supervisedTag;
    }
    try {
      const response = await this.request({
        path: `/statistics/v2/${interval}`,
        method: 'GET',
        query: queryParameters,
      });
      return (response.data as StatisticsOverview) ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

/**
 * Lokalt datum som yyyy-MM-dd. toISOString() går via UTC och ger föregående dag för en
 * midnatt i svensk tid, vilket flyttar hela perioden en dag bakåt.
 */
const toLocalDateString = (date: Date): string => {
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};
